import { render, staticRenderFns } from "./DocumentsSales.vue?vue&type=template&id=c97fd038&"
import script from "./DocumentsSales.vue?vue&type=script&lang=js&"
export * from "./DocumentsSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports